/**
 * DB の改行区切り・半角/全角スペース・カンマ等で連結された電話番号を配列に分解する。
 */
export function parseTelNumbers(tel: string | null | undefined): string[] {
  if (tel == null || tel === '') {
    return []
  }
  const raw = String(tel)
  const secondary = /[\s,;\/　\u3000\u00A0\x0B]+/u
  const parts = raw
    .split(/\r\n|\n|\r|\u2028|\u2029/)
    .flatMap((segment) =>
      segment.split(secondary).map((t) => t.trim())
    )
    .filter(Boolean)

  const seen = new Set<string>()
  return parts.filter((p) => {
    if (seen.has(p)) {
      return false
    }
    seen.add(p)
    return true
  })
}
